// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__eP+i4","main":"MainLayout_main__BXKlz"};